import { AppLoading } from "components/App/components/AppLoading";
import { useCompanyContext } from "context/companyContext";
import { useAuthenticatedUser } from "hooks/useAuthenticatedUser";
import { useEffect } from "react";

export const AuthGate: FC = ({ children }) => {
  const { loading, user } = useAuthenticatedUser();
  const {
    actions: { loadCompany },
    state: { company },
  } = useCompanyContext();

  useEffect(() => {
    if (user) void loadCompany();
  }, [loadCompany, user]);

  if (loading || (user && !company)) return <AppLoading />;
  return <>{children}</>;
};
